import { createProject } from '@lib/api'
import { adminProjectsKeys } from '@lib/keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useCreateProject = () => {
  const queryClient = useQueryClient()

  return useMutation(({ name }: { name: string }) => createProject(name), {
    onSuccess: () => {
      void queryClient.invalidateQueries(adminProjectsKeys.all)
    },
  })
}
